// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormWrapper_wrapper__Ax1xD","small":"FormWrapper_small__1B7Oq"};